var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('app-modal',{attrs:{"name":"app-directory-modal","title":_vm.title,"width":"30%"},on:{"before-open":_vm.beforeOpen,"on-cancel":_vm.onCancel,"on-ok":_vm.onOk}},[_c('app-directory',{ref:"directory",attrs:{"edit":true}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3f4c54db","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/portal-components/directory-list/app-directory-modal.vue
// module id = x9Es
// module chunks = 23